import { useMinimalsTheme } from '@tom-ui/ui'

export const RequiredField = () => {
  const theme = useMinimalsTheme()

  return <span style={{ color: theme.palette.error.main }}>*</span>
}
